// extracted by mini-css-extract-plugin
module.exports = {"ds9LoadingIcon":"Loader_ds9LoadingIcon__d2RnV","fade":"Loader_fade__i0t9c","ds9LoadingIconSpinner":"Loader_ds9LoadingIconSpinner__v3bQU","spin":"Loader_spin__mFUxX"};